import { EntityServices } from "@sdk/utils/entity.service";
import type { PaginatedOptions, PaginatedResults } from "@sdk/utils/paginated-results";
import type { iCustomerPaymentReceipt } from "@sdk/bookings/booking-model";
import { postAccountingListReport } from "@sdk/accounting/accounting-list-report.service";
import type { CustomerPaymentReceiptListRow } from "@sdk/accounting/accounting-list-report.models";

export class CustomerPaymentReceiptsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.customerPaymentReceipts.configure(config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.customerPaymentReceipts = Object.assign(
      new EntityServices<iCustomerPaymentReceipt>(
        config,
        "customer-payment-receipts",
        {}
      ),
      {
        report: (req: {
          query: Record<string, unknown>;
          options?: PaginatedOptions;
        }) =>
          postAccountingListReport<CustomerPaymentReceiptListRow>(
            config,
            "customer-payment-receipts",
            req
          ),
      }
    );
    this.customerPaymentReceipts.configure(config);
  }

  customerPaymentReceipts!: EntityServices<iCustomerPaymentReceipt> & {
    report: (req: {
      query: Record<string, unknown>;
      options?: PaginatedOptions;
    }) => Promise<PaginatedResults<CustomerPaymentReceiptListRow>>;
  };
}
